import { Cls, Emojis } from 'app/constants';
import { store } from 'app/store';
import { GameWeek, ITeamStandings } from 'types';

export type StandingLoaderPayload = {
  year: number;
  weekNum: GameWeek;
  seasonStandings: ITeamStandings[];
};

export const standingsLoader = async ({ params }: any): Promise<StandingLoaderPayload | Response> => {
  const yearId = params.yearId;
  const weekId = params.weekId;

  const msg = `${Emojis.eyes} %c standingsLoader %c %c ${location.href} %c`;
  console.log(msg, Cls.Loc, '', Cls.Msg, '');

  const seasonStandings: ITeamStandings[] = store.getState().stats.seasonStandings;

  return {
    year: yearId,
    weekNum: weekId,
    seasonStandings,
  };
};
